/* eslint-disable no-useless-escape */
export const USER_LOCAL_STORE = 'currentTPestUser';
export const UNAUTHORIZED = 401;
export const NOT_FOUND = 404;
export const INTERNAL_SERVER_ERROR = 500;
export const BAD_REQUEST = 400;
export const CREATED = 201;
export const OK = 200;
export const FORBIDDEN = 403;
export const MAINTENANCE = 502;
export const USER_REMEMBER_LOCAL_STORE = 'userRemember';
export const SUPER_ADMIN_ROLE = 'ROLE_SUPER_ADMIN';
export const SIZE_NAME = 'T-Pest';
export const FORMAT_DATE = 'MM/DD/yyyy';
export const FORMAT_DATETIME = 'hh:mm:ss MM/DD/yyyy';
export const FORMAT_DATETIME_CHART = 'hh:mm-MM/DD';
export const FORMAT_DATE_MONTH = 'MM/DD';
export const BINH_DINH_PROVINCE_ID = 1;
export const MIN_LENGTH_PASSWORD = 6;
export const LENGTH_FG_REQ_ADD_BODY = 7;
export const LENGTH_FG_REQ_UPDATE_BODY = 4;
// export const PHONE_NUMBER_REGEX = /^[0-9\+]{1,}[0-9\-]{3,15}$/;
export const PHONE_NUMBER_REGEX = /^0\d{9,10}$/;
export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const DEFAULT_VARIETY_IDS = [1, 2, 3, 4];
export const NUMBER_REGEX = /^[\d.,]+$/;
export const CURRENT_TPEST_USER = 'currentTPestUser';
export const WIND_REGEX = /^[^\d]*$/;
export const SENT_NOTIFICATION = 'sent';

export const CONSTANTS = Object.freeze({
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_30: 30,
  SORT_DESC: 'DESC',
  SORT_ASC: 'ASC',
  NOT_HAVE_ORIGIN: 'Nguồn gốc đang bị bỏ trống',
  NOT_HAVE_SOIL_TYPE: 'Loại đất đang bị bỏ trống',
  NUMBER_DEBOUNCED_INPUT_SEARCH: 800,
  MAX_LENGTH_PASSWORD: 20,
  MIN_LENGTH_PASSWORD: 6,
  MAX_LENGTH_USERNAME: 10,
  FORMAT_WRONG_USERNAME: /^[a-zA-Z0-9]+$/,
  NUMBER_REGEX: /^\d+$/,
  FORMAT_WRONG_POSITION_MAP: /^-?[\d]{1,3}\.[\d]+,\s?-?[\d]{1,3}\.[\d]+$/,
  POSITION_QUYNHON_CENTER: [14.103280649946063, 109.04205322265626],
  WIND_DIRECTION: ['Hướng Đông', 'Hướng Tây', 'Hướng Bắc', 'Hướng Nam', 'Hướng Đông Bắc', 'Hướng Đông Nam', 'Hướng Tây Bắc', 'Hướng Tây Nam'],
  TYPE_PESTS: 1,
  TYPE_DISEASE: 2,
  ERROR_MESSAGE_SYSTEMS: {
    vi: 'Lỗi hệ thống',
    en: 'System error',
  },
  UNAUTHORIZED_MESSAGE_SYSTEMS: {
    vi: 'Phiên đăng nhập đã kết thúc, vui lòng đăng nhập lại',
    en: 'Unauthorized error 401',
  },
  TYPE_MACHINE_ONLINE: 'Hoạt động',
  TYPE_NOTIFY_SENT: 'sent',
  TYPE_MACHINE_OFFLINE: 'Không hoạt động',
  TYPE_MACHINE_DEACTIVATION: 'Vô hiệu hóa',
  TYPE_MACHINE_UNKNOWN: 'Không xác định',
  MAX_LENGTH_UPLOAD_FILE: 20,
  TIME_REFRESH_API_NOTIFY: 300000, // 5 * (60 * 1000) = 5 mins
  DATE_OF_WEEKS: [
    {
      value: 1,
      text: 'Thứ 2',
    },
    {
      value: 2,
      text: 'Thứ 3',
    },
    {
      value: 3,
      text: 'Thứ 4',
    },
    {
      value: 4,
      text: 'Thứ 5',
    },
    {
      value: 5,
      text: 'Thứ 6',
    },
    {
      value: 6,
      text: 'Thứ 7',
    },
    {
      value: 0,
      text: 'Chủ Nhật',
    },
    {
      value: 7,
      text: 'Hằng ngày',
    },
  ],
  DATE_OF_WEEKS_TEXT: ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Hằng ngày'],
  REPORT_TYPE: [
    {
      value: 'week',
      text: 'Theo tuần',
    },
    {
      value: 'month',
      text: 'Theo tháng',
    },
    {
      value: 'crop',
      text: 'Theo vụ',
    },
    {
      value: 'year',
      text: 'Theo năm',
    },
  ],
  REPORT_FILTE_NAME: ['BCTH-QM-DTDH', 'CTDTH'],
  INFO_FILTER_HARM_TYPE: [
    {
      value: 'infectedCrop',
      text: 'Phần nhập liệu',
    },
    {
      value: 'pestDetection',
      text: 'Máy nhận diện sâu bệnh',
    },
  ],
  MAX_ROWS_SCHEDULE: 15,
  RICE_DISEASE: 'RICE_DISEASE',
  RICE_PEST: 'RICE_PEST',
});

export const SEARCH_LOCAL_STORAGE_KEY = {
  INPUT_PRODUCTIVITY: 'inputProductivity',
  INPUT_RICE_STRUCTURE: 'inputRiceStructure',
  INPUT_PEST: 'inputPest',
  INPUT_FARMING_PROGRESS: 'inputFarmingProgress',
  INPUT_WEATHER: 'inputWeather',
};
export const MANAGEMENT_LOCAL_STORAGE_KEY = {
  HARMFUL_ORGANISMS: 'harmfulOrganisms',
  RICE_VARIETIES: 'riceVarieties',
  GROWTH_STAGE: 'growthStage',
  CROPS: 'crops',
  DISTRICT: 'district',
  WARDS: 'wards',
  USERS: 'users',
  NOTIFICATION: 'notification',
  MACHINES: 'machines',
};
export const PEST_IDENTIFICATION_LOCAL_STORAGE_KEY = {
  IDENTIFICATION_ON_RICE: 'identificationOnRice',
  IDENTIFICATION_ON_MACHINE: 'identificationOnMachine',
};
export const TYPE_PESTS_TEXT = 'sauhai';
export const TYPE_DISEASE_TEXT = 'benh';
export const TYPE_MOBILE = 'mobile';
export const TYPE_MACHINE = 'machine';
